
import {
  stats,
  serviceFeatures,
  popularServices,
  solotionTabItems,
  questions,
  objectStorage,
  locations,
  uses,
} from "~/data/objectStorage";
import Modal from "~/components/rebranding/modal/Modal.vue";
import Uses from "~/components/object-storage/uses.vue";
export default {
  components: {
    Modal,
    Uses,
  },
  data() {
    return {
      activeSection: "",
      FormTitle: "",
      statsData: stats,
      serviceFeatures,
      popularServices,
      solotionTabItems,
      questions,
      objectStorage,
      locations,
      uses,
      solotionTab: 0,
    };
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "آبجکت استوریج آبالون | ذخیره‌سازی امن و مقرون‌به‌صرفه",
      meta: [
        {
          name: "description",
          content:
            "خرید فضای ابری | ذخیره‌سازی در فضای ابری‌ با آبجکت استوریج آبالون | سازگار با S3 | راهکاری مقرون‌به‌صرفه و منعطف که با نیاز شما رشد می‌کند.",
        },
        {
          name: "keywords",
          content: "آبجکت استوریج",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/object-storage",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "آبجکت استوریج آبالون | ذخیره‌سازی امن و مقرون‌به‌صرفه",
        },
        {
          property: "og:description",
          content:
            "خرید فضای ابری | ذخیره‌سازی در فضای ابری‌ با آبجکت استوریج آبالون | سازگار با S3 | راهکاری مقرون‌به‌صرفه و منعطف که با نیاز شما رشد می‌کند.",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/object-storage",
        },
        {
          name: "twitter:title",
          title: "آبجکت استوریج آبالون | ذخیره‌سازی امن و مقرون‌به‌صرفه",
        },
        {
          name: "twitter:description",
          content:
            "خرید فضای ابری | ذخیره‌سازی در فضای ابری‌ با آبجکت استوریج آبالون | سازگار با S3 | راهکاری مقرون‌به‌صرفه و منعطف که با نیاز شما رشد می‌کند.",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/object-storage",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "آیا آبجکت استوریج آبالون امکان رمزگذاری داده‌ها را فراهم می‌کند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، برای افزایش امنیت اطلاعات، آبالون از رمزگذاری داده‌ها در حالت سکون (at rest) و همچنین حین انتقال (in transit) پشتیبانی می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "چطور می‌توان دسترسی کاربران به فایل‌ها را در آبجکت استوریج آبالون مدیریت کرد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "با استفاده از سیاست‌های دسترسی و مدیریت کلیدها به صورت مبتنی بر S3، می‌توان سطح دسترسی هر کاربر یا گروه را برای فایل‌ها و باکت‌ها کنترل کرد.",
                },
              },
              {
                "@type": "Question",
                name: "آیا آبجکت استوریج آبالون از نسخه‌بندی فایل (Versioning) پشتیبانی می‌کند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، با فعال‌سازی قابلیت Versioning می‌توانید نسخه‌های مختلف یک فایل را نگهداری کرده و در صورت نیاز هر نسخه را بازیابی کنید.",
                },
              },
              {
                "@type": "Question",
                name: "چگونه می‌توان فایل‌ها را از طریق رابط کاربری گرافیکی (GUI) در آبجکت استوریج آبالون مدیریت کرد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "آبالون علاوه بر API و CLI، یک رابط کاربری گرافیکی ساده و کارآمد ارائه می‌دهد که به شما امکان بارگذاری، دانلود، حذف و مدیریت فایل‌ها و باکت‌ها را به صورت بصری می‌دهد.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان تعریف قوانین Lifecycle برای داده‌ها در آبجکت استوریج آبالون وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، شما می‌توانید برای انتقال خودکار داده‌ها بین بخش‌های Hot و Cold یا حذف خودکار داده‌ها پس از یک مدت مشخص، قوانین مدیریت چرخه عمر (Lifecycle) تعریف کنید.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "خدمات تخصصی دواپس آبالون",
            },
            author: {
              "@type": "Person",
              name: "Hamid Karimi",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
};
